import constants from '@/util/constants.js'

export const temNomeEmpresa = ({ nomeEmpresa }) => !!nomeEmpresa
export const temEmailUsuario = ({ emailUsuario }) => !!emailUsuario
export const temCpfCnpj = ({ cpfCnpj }) => !!cpfCnpj
export const temNomeUsuarioLogado = ({ nomeUsuarioLogado }) => !!nomeUsuarioLogado
export const temLogoCliente = ({ logoCliente }) => !!logoCliente
export const temEscritorio = ({ escritorio }) => !!escritorio
export const temTipoDeAcesso = ({ tipoDeAcesso }) => !!tipoDeAcesso
export const temAcessoAoFaturamento = ({ temAcessoAoFaturamento }) => !!temAcessoAoFaturamento
export const temAcessoAoFinanceiro = ({ temAcessoAoFinanceiro }) => !!temAcessoAoFinanceiro
export const temAcessoAosRelatorios = ({ temAcessoAosRelatorios }) => !!temAcessoAosRelatorios
export const temAcessoAoEscritorio = ({ temAcessoAoEscritorio }) => !!temAcessoAoEscritorio
export const opcaoMenuSistemaJuridico = ({ loginStrategy }) => loginStrategy === constants.loginStrategy.legacyLogin
export const opcaoMenuGestaoConta = ({ loginStrategy }) => loginStrategy === constants.loginStrategy.managerLogin
export const temRegrasLogin = ({ regrasLogin }) => !!regrasLogin
export const temRepresentanteLegal = ({ representanteLegal }) => !!representanteLegal
export const escritorioInadimplente = ({ escritorioInadimplente }) => !!escritorioInadimplente
export const temDadosAlertaVencimento = ({ dadosAlertavencimento }) => !!dadosAlertavencimento
export const dadosCampanhaMarketing = ({ dadosCampanhaMarketing }) => dadosCampanhaMarketing
export const ocultarOpcaoMenuBanco = ({ ocultarOpcaoMenuBanco }) => !!ocultarOpcaoMenuBanco
